import ObjectID from 'bson-objectid';
import { toDomesticPhoneFormat } from '../../Common/utils';
import { changeDeviceOwnership, fetchBodytraceDevices } from '../../../services/RegistryApi';

export const changeOwnership = async (
  _id,
  memberList,
  ownerMap,
  setOwnerMap,
  setLoading,
) => {
  setLoading(true);
  try {
    const newOwner = memberList.find(
      (x) => x._id === ownerMap[_id].memberId,
    );

    if (!newOwner) {
      throw new Error('New owner not found');
    }

    // Prepare new owner info for the API
    const newOwnerInfo = {
      name: newOwner.name,
      phone: newOwner.phone,
      email: newOwner.email,
      memberId: newOwner._id === '' ? '' : newOwner._id,
    };

    // Call the API to change device ownership
    await changeDeviceOwnership(
      ownerMap[_id].imei,
      newOwnerInfo
    );

    // Update the local state with the new owner info
    setOwnerMap({
      ...ownerMap,
      [_id]: {
        ...ownerMap[_id],
        name: newOwner.name,
        phone: newOwner.phone,
        email: newOwner.email,
        memberId: newOwner._id,
        text: newOwner.text,
        clicked: false,
        changed: false,
      },
    });
  } catch (error) {
    console.error('Error changing device ownership:', error);
    // You might want to show an error message to the user here
    throw error;
  } finally {
    setLoading(false);
  }
};

export const getMembers = async (
  isMounted,
  setMemberList,
  actions
) => {
  let res = [];
  // Aug 16, 2021, Yubin
  // Devices > # device-assignment was not loading; time-out (for Renal Consultants)
  // Realized the members collection lacked a compound index that is given below
  // Added the index to the collection, and now the issue is resolved
  let projection = {
    _id: { $toString: '$_id' },
    name: 1,
    phone: 1,
  };

  let sort = { name: 1 };

  res = await actions.fetchMembersByQuery({}, projection, sort);

  const membersListResponse = res.map((member) => {
    const text =
      member.name !== ''
        ? member.name + ', ' + toDomesticPhoneFormat(member.phone)
        : '';
    return {
      key: member._id,
      value: member._id,
      _id: member._id,
      name: member.name,
      phone: member.phone,
      email: member.email,
      text: text,
    };
  });
  membersListResponse.push({
    key: '',
    value: '',
    _id: '',
    name: '',
    phone: '',
    text: 'no owner',
  });
  if (isMounted) {
    setMemberList(membersListResponse);
  }
};

export const fetchDevices = async (
  superUserAccess,
  userCustomData,
  deviceMap,
  isMounted,
  setOwnerMap,
  setDevices,
  setStats,
) => {
  try {
    let devicesRegistry = [];
    let devicesOwnerMap = {};
    let stats = {};

    // Build query based on user access
    const query = {
      device: { $in: ['BT004', 'BT105', 'SMIG'] }
    };

    // Add owner_id filter for non-super users
    if (!superUserAccess) {
      query.owner_id = userCustomData.group_id;
    }

    // Call the API to get devices
    const response = await fetchBodytraceDevices(query, {
      sort: { lastUsed: -1 }
    });

    devicesRegistry = response || [];

    // Process devices data
    devicesRegistry.forEach((device) => {
      const text =
        device.name !== ''
          ? device.name + ', ' + toDomesticPhoneFormat(device.phone)
          : '';
      device.deviceType = deviceMap[device.device] || device.device;
      devicesOwnerMap[device._id] = {
        imei: device.imei,
        name: device.name,
        phone: device.phone,
        email: device.email,
        text: text,
        memberId:
          device.memberId === ''
            ? ObjectID(null).toHexString()
            : device.memberId,
        clicked: false,
        changed: false,
      };
      stats[device.deviceType] = stats[device.deviceType]
        ? stats[device.deviceType] + 1
        : 1;
    });

    if (isMounted) {
      setOwnerMap(devicesOwnerMap);
      setDevices(devicesRegistry);
      setStats(Object.entries(stats));
    }
  } catch (error) {
    console.error('Error fetching devices:', error);
    // Set empty arrays on error
    if (isMounted) {
      setOwnerMap({});
      setDevices([]);
      setStats([]);
    }
  }
};
